import React from 'react';

function Footer() {
  return (
    <footer className="app-footer">
      <div className="footer-content">
        <p className="footer-tagline">
          This site was created by caffeine, ramen, and a robot 🤖
        </p>
        <p className="footer-copyright">
          © 2026 Patch My PC. All rights reserved.
        </p>
      </div>
    </footer>
  );
}

export default Footer;
